import { useParams, Navigate } from 'react-router-dom';
import { getFeatureBySlug } from '../data/features';
import { FeaturePageTemplate } from '../components/marketing/FeaturePageTemplate';

export function FeaturePage(): JSX.Element {
  const { slug } = useParams<{ slug: string }>();
  const feature = slug ? getFeatureBySlug(slug) : undefined;

  if (!feature) {
    return <Navigate to="/features" replace />;
  }

  return <FeaturePageTemplate feature={feature} />;
}
